import script from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=07da54f8&lang=css"

const __exports__ = script;

export default __exports__